import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { HOME_URL, VENUES} from '../../../const/URL.const';
import { useAuthenticationContext } from '../../../yoello-lib/modules/auth/AuthenticationContext';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';
import { ISetNewPassword } from '../types';
import { useCheckUserVerification } from '../util/useCheckUserVerification';
import { useUserLogout } from '../../../hooks/useUserLogout';

export function useSetPasswordView(oldPassword:string) {
  useCheckUserVerification();
  const { forceResetPassword } = useAuthenticationContext();
  const { logout } = useUserLogout();
  const [ isLoading , setIsLoading] = useState<boolean>(false);
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const history = useHistory();
  const { t }  = useTranslation();

  useEffect(()=>{
    if(!oldPassword){
      history.push(HOME_URL);
      sendSnackbarMessage(
        t("forms.forgotPassword.Errors.invalidEmail").toString(),
        "error"
      );
    }
  // eslint-disable-next-line  
  },[oldPassword])

  async function setPassword ({username, oldPassword , password, confirmPassword}:ISetNewPassword){
    setIsLoading(true);
    if (password !== confirmPassword) {
      sendSnackbarMessage(
        t("forms.forgotPassword.Errors.passwordMismatch").toString(),
        "error"
      );
      setIsLoading(false);
      return;
    }
    try {
      await forceResetPassword(username,oldPassword, password);
      history.push(VENUES);
    } catch (error) {
      sendSnackbarMessage(
        t("forms.newPassword.Errors.setPassword").toString(),
        "error"
      );
      logout();
    }
  }

  return {
    isLoading,
    setPassword
  }
}
